import { render, staticRenderFns } from "./DetailInformasiUmum.vue?vue&type=template&id=0e556976&"
import script from "./DetailInformasiUmum.vue?vue&type=script&lang=js&"
export * from "./DetailInformasiUmum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports